import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import * as moment from "moment";
import "moment-timezone";
import { KpiService } from "../../kpi/kpi.service";
import { TIERS } from "../../constants";

@Component({
  selector: "metric-settings-preview",
  templateUrl: "./metric-settings-preview.component.html",
  styleUrls: ["./metric-settings-preview.component.scss"],
})
export class MetricSettingsPreviewComponent implements OnInit, OnChanges {
  @Input() metric;
  @Input() selectedMetricData;
  @Input() district;
  @Input() goals;

  tooltipText =
    "Visible metrics will show up on all Mosaic dashboards. Changes will take effect within 24 hours.";
  refreshDate;
  isStarterUser: boolean;
  rgpTenantId: string;

  constructor(private kpiService: KpiService) {}

  ngOnInit() {
    this.kpiService.getUserInfo().subscribe((data) => {
      this.isStarterUser = data.sz_tier == TIERS.STARTER.key;
      this.rgpTenantId = data.rgp_tenant;
    });
  }

  ngOnChanges(change) {
    if (change && change.selectedMetricData) {
      if (this.selectedMetricData && this.selectedMetricData.jsonLastUpdated) {
        this.refreshDate = moment
          .tz(this.selectedMetricData.jsonLastUpdated, "America/Los_Angeles")
          .format("MMM D, YYYY, h:mm:ss A");
      } else {
        this.refreshDate = "----";
      }
    }
  }
}
